import { REQUIRED_MESSAGE, fileSchema, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { associatedCriteriaFormSchema } from '~/common/schemas';

export const DESTOCKING_POLICY_STATUS = {
  ACTIVE: 'active',
  ENDED: 'ended',
} as const;

export const destockingCriterionSchema = z.object({
  id: z.string(),
  criterion: z.string(),
  code: z.string(),
  value: z.string(),
});

export const destockingPricingPolicySchema = z.object({
  id: z.string(),
  name: z.string(),
  supplierIds: z.array(z.number()),
  suppliers: z.array(z.object({ id: z.number(), name: z.string().nullable() })),
  criteria: z.array(destockingCriterionSchema),
  status: z.nativeEnum(DESTOCKING_POLICY_STATUS),
  startDate: z.string(),
  closedAt: z.string().nullable(),
  createdAt: z.string().nullable(),
  uploadedFileName: z.string(),
});

export const destockingPolicyForm = z.object({
  name: requiredString,
  supplierIds: z.array(z.number()).min(1, { message: REQUIRED_MESSAGE }),
  criteria: z
    .array(associatedCriteriaFormSchema)
    .min(1, { message: REQUIRED_MESSAGE }),
  // display-only, UPDATE mode
  uploadedFileName: z.string().optional(),
});

export const createDestockingPolicyForm = destockingPolicyForm.extend({
  file: fileSchema,
});
